import { AbstractLayout } from "../AbstractLayout";
export class ToggleLayout extends AbstractLayout {
    /**
     * Create a Bootstrap Toggle control in the given container.
     * @implements AbstractLayout
     * @param container the container for the control
     */
    createControl(container) {
        this.input.type = "checkbox";
        container.appendChild(this.input);
        this.input.bootstrapToggle({
            onlabel: this.lightLabel,
            offlabel: this.darkLabel,
            onstyle: this.style,
            offstyle: this.style,
        });
    }
    /**
     * Lazy initialization getter for the input control element.
     * If the input element is not already created, it will be created using `document.createElement("input")`.
     * @returns {BootstrapToggleElement} the button control element.
     */
    get input() {
        var _a;
        (_a = this._input) !== null && _a !== void 0 ? _a : (this._input = globalThis.document.createElement("input"));
        return this._input;
    }
    /**
     * Update the state of the control element based on the given boolean.
     * @implements AbstractLayout
     * @param {boolean} isLight - A boolean indicating whether to set light mode (`true`) or dark mode (`false`)
     */
    updateControlState(isLight) {
        this.input.bootstrapToggle(isLight ? BootstrapToggleMethods.ON : BootstrapToggleMethods.OFF, true);
    }
    /**
     * Attach a callback handler for the control element `change event`.
     * @implements AbstractLayout
     * @param {(e: Event) => void} handler - The callback handler to blink
     */
    onChange(handler) {
        this.input.addEventListener("change", handler);
    }
}
export var BootstrapToggleMethods;
(function (BootstrapToggleMethods) {
    BootstrapToggleMethods["ON"] = "ON";
    BootstrapToggleMethods["OFF"] = "OFF";
    BootstrapToggleMethods["TOGGLE"] = "TOGGLE";
    BootstrapToggleMethods["DETERMINATE"] = "DETERMINATE";
    BootstrapToggleMethods["INDETERMINATE"] = "INDETERMINATE";
    BootstrapToggleMethods["ENABLE"] = "ENABLE";
    BootstrapToggleMethods["DISABLE"] = "DISABLE";
    BootstrapToggleMethods["READONLY"] = "READONLY";
    BootstrapToggleMethods["DESTROY"] = "DESTROY";
    BootstrapToggleMethods["RENDERER"] = "RENDERER";
})(BootstrapToggleMethods || (BootstrapToggleMethods = {}));
